import * as React from 'react';
import { AgendaEventsListView } from './AgendaEventsListView';
import { observer } from 'mobx-react-lite';
import { isScenarioInitialized } from '../selectors/agendaStoreSelectors';
import { AgendaCallbacks } from '../store/schema/AgendaCallbacks';

export interface AgendaEventsViewProps {
    scenarioId: string;
    callbacks?: AgendaCallbacks;
    styles?: { listContainer: string };
}

export const AgendaEventsView = observer(function AgendaEventsView(props: AgendaEventsViewProps) {
    const { scenarioId, callbacks, styles } = props;
    return isScenarioInitialized(scenarioId) ? (
        <AgendaEventsListView scenarioId={scenarioId} callbacks={callbacks} styles={styles} />
    ) : null;
});
